<app-base-overlay [title]="title()" [description]="description()">
  <div body class="flex min-h-0 flex-col gap-4">
    <div class="flex items-center justify-end">
      <button
        type="button"
        class="inline-flex cursor-pointer items-center gap-1.5 border-0 bg-transparent p-0 text-sm font-medium text-primary-600 transition hover:text-primary-700"
        (click)="openDataPreview()">
        <app-svg-icon src="assets/icons/eye-outline.svg" [size]="16" />
        Preview data
      </button>
    </div>

    @if (isLoading()) {
      <p class="py-4 text-center text-sm text-slate-500">Loading columns…</p>
    } @else if (isEmpty()) {
      <p class="py-4 text-center text-sm text-slate-500">
        This collection has no columns yet.
      </p>
    } @else if (isPrimarySecondary()) {
      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-2">
          <span class="text-sm font-medium text-slate-700">Primary display</span>
          <div
            class="max-h-[10rem] overflow-y-auto rounded-xl border border-slate-200 bg-slate-50/60 px-3 py-2.5">
            <div class="flex flex-col gap-2.5">
              @for (column of columns(); track column.key) {
                <lib-signal-radio
                  [label]="column.label"
                  groupName="collection-primary-column"
                  [optionValue]="column.key"
                  [value]="selectedKey()"
                  (valueChange)="onColumnChange($event)" />
              }
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-2">
          <span class="text-sm font-medium text-slate-700">Secondary display</span>
          <div
            class="max-h-[10rem] overflow-y-auto rounded-xl border border-slate-200 bg-slate-50/60 px-3 py-2.5">
            <div class="flex flex-col gap-2.5">
              @for (column of columns(); track column.key) {
                <lib-signal-radio
                  [label]="column.label"
                  groupName="collection-secondary-column"
                  [optionValue]="column.key"
                  [value]="selectedSecondaryKey()"
                  (valueChange)="onSecondaryColumnChange($event)" />
              }
            </div>
          </div>
          @if (
            selectedKey() &&
            selectedSecondaryKey() &&
            selectedKey() === selectedSecondaryKey()
          ) {
            <p class="text-xs text-rose-600">
              Primary and secondary must be different fields.
            </p>
          }
        </div>
      </div>
    } @else {
      <div class="flex flex-col gap-2">
        <span class="text-sm font-medium text-slate-700">Field</span>
        <div
          class="max-h-[14rem] overflow-y-auto rounded-xl border border-slate-200 bg-slate-50/60 px-3 py-2.5">
          <div class="flex flex-col gap-2.5">
            @for (column of columns(); track column.key) {
              <lib-signal-radio
                [label]="column.label"
                groupName="collection-show-as-column"
                [optionValue]="column.key"
                [value]="selectedKey()"
                (valueChange)="onColumnChange($event)" />
            }
          </div>
        </div>
      </div>
    }

    @if (!isLoading() && !isEmpty()) {
      <lib-signal-dropdown
        label="Default value"
        placeholder="Choose a default (optional)"
        [items]="defaultItems()"
        valuePath="id"
        displayPath="display"
        [showClearButton]="true"
        [value]="selectedDefaultItemId()"
        (valueChange)="onDefaultChange($event)" />
    }
  </div>

  <div actions class="flex flex-wrap justify-end gap-3">
    <lib-signal-button
      appearance="outline"
      [fullWidth]="false"
      (clicked)="cancel()">
      Cancel
    </lib-signal-button>
    <lib-signal-button
      [fullWidth]="false"
      [disabled]="!canConfirm()"
      (clicked)="confirm()">
      OK
    </lib-signal-button>
  </div>
</app-base-overlay>
